import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DeadlineTypeEnum } from '@zaoblako/shared/common/enums/deadline.type.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { DeadlineTypeNamePipe } from '@zaoblako/web/shared/pipes/deadline-type-name.pipe';

@Component({
  standalone: true,
  selector: 'crm-deadline-type-single-select',
  templateUrl: './deadline-type-single-select.component.html',
  imports: [CommonModule, SingleSelectComponent, DeadlineTypeNamePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeadlineTypeSingleSelectComponent {
  @Input() public type: DeadlineTypeEnum;
  @Output() public typeChange = new EventEmitter<DeadlineTypeEnum>();

  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: string;

  public options = Object.values(DeadlineTypeEnum);
}
